import { ExclamationCircleOutlined } from '@ant-design/icons'
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Tabs,
} from 'antd'
import React from 'react'
import { useRef } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent'
import commonStore from '../../../stores/commonStore'
import validator from '../../../validator'

const { TextArea } = Input

const RiskTemplateCreateModal = ({
  showCreateModal,
  handleCancelCreateModal,
  type,
  riskTemplateStore,
  loadRiskTemplateList,
  handleCancelEditModal,
  risk,
  setEditRisk,
}) => {
  const { Option } = Select
  const { createRiskTemplate, updateRiskTemplate } = riskTemplateStore
  const [form] = Form.useForm()
  const CAUSE_REF = useRef()
  const MEASURE_REF = useRef()
  const [isRenderRichText, setIsRenderRichText] = useState(false)
  useEffect(() => {
    if (!risk || !showCreateModal) {
      return
    }

    setTimeout(() => {
      form.setFieldsValue({
        rui_ro_nhan_dien: risk.rui_ro_nhan_dien,
        linh_vuc_hoat_dong: risk?.linh_vuc_hoat_dong || null,
        type: risk.type,
      })
    }, 0)
  }, [risk, form, showCreateModal])

  const [buttonBlock, setButtonBlock] = useState(false)

  useEffect(() => {
    if (showCreateModal) {
      setTimeout(() => {
        setIsRenderRichText(true)
      }, 400)
    } else {
      setIsRenderRichText(false)
    }
  }, [showCreateModal])
  const handleCreateRisk = async value => {
    setButtonBlock(true)
    const submitData = {
      linh_vuc_hoat_dong: value.linh_vuc_hoat_dong,
      rui_ro_nhan_dien: value.rui_ro_nhan_dien,
      nguyen_nhan: CAUSE_REF.current.editor.getData(),
      bien_phap_phong_ngua_giam_thieu: MEASURE_REF.current.editor.getData(),
      type: value.type,
    }
    try {
      risk
        ? await updateRiskTemplate(risk.id, submitData)
        : await createRiskTemplate(submitData)
      await loadRiskTemplateList()
      risk
        ? message.success('Cập nhật thành công')
        : message.success('Tạo mới thành công')
      handleCancelCreateModal()
      setEditRisk(null)
    } catch {
      message.error('Đã có lỗi xảy ra')
    }
  }
  const { riskTemplateTypes } = riskTemplateStore

  return (
    <Modal
      visible={showCreateModal}
      footer={null}
      destroyOnClose={true}
      afterClose={() => {
        setButtonBlock(false)
        setIsRenderRichText(false)
      }}
      wrapClassName="custom-modal-wrapper"
      width={900}
      onCancel={risk ? handleCancelEditModal : handleCancelCreateModal}
      title={risk ? 'Cập nhật rủi ro nhận diện' : 'Tạo mới rủi ro nhận diện'}>
      <Form
        layout={'vertical'}
        onFinish={handleCreateRisk}
        preserve={false}
        form={form}>
        <Form.Item
          label={'Loại'}
          name={'type'}
          rules={[{ required: true, message: 'Vui lòng chọn !' }]}>
          <Select
            style={{ minWidth: '250px' }}
            placeholder={'Chọn loại'}
            allowClear
            showSearch
            filterOption={(input, option) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={risk ? true : false}>
            {riskTemplateTypes?.length > 0 &&
              riskTemplateTypes.map(type => (
                <Option key={type.code} value={type.code}>
                  {type.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item
          label={'Lĩnh vực hoạt động'}
          name={'linh_vuc_hoat_dong'}
          rules={[
            { required: true, message: 'Vui lòng nhập !' },
            { validator: validator.validateInputString },
          ]}>
          <Input placeholder={'Nhập lĩnh vực hoạt động'} />
        </Form.Item>
        <Form.Item
          label={'Rủi ro nhận diện'}
          name={'rui_ro_nhan_dien'}
          rules={[
            { required: true, message: 'Vui lòng nhập !' },
            { validator: validator.validateInputString },
          ]}>
          <TextArea rows={3} placeholder={'Nhập rủi ro nhận diện'} />
        </Form.Item>

        <Tabs defaultActiveKey="1" destroyInactiveTabPane={false}>
          <Tabs.TabPane tab="Nguyên nhân" key="1" forceRender>
            {!isRenderRichText && (
              <div style={{ height: 312, position: 'relative' }}>
                <SpinnerInlineComponent
                  sizeSpin={'small'}
                  tip="Đang tải dữ liệu..."
                  isLoading={!isRenderRichText}
                  backGround={'#ffffffc7'}
                />
              </div>
            )}
            <Form.Item name={'nguyen_nhan'}>
              {isRenderRichText && (
                <RichEditor
                  EDITOR_REF={CAUSE_REF}
                  placeholder={'Nhập nội dung...'}
                  editorContent={risk?.nguyen_nhan}
                />
              )}
            </Form.Item>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab="Biện pháp phòng ngừa giảm thiểu"
            key="2"
            forceRender>
            {!isRenderRichText && (
              <div style={{ height: 312, position: 'relative' }}>
                <SpinnerInlineComponent
                  sizeSpin={'small'}
                  tip="Đang tải dữ liệu..."
                  isLoading={!isRenderRichText}
                  backGround={'#ffffffc7'}
                />
              </div>
            )}
            <Form.Item name={'bien_phap_phong_ngua_giam_thieu'}>
              {isRenderRichText && (
                <RichEditor
                  EDITOR_REF={MEASURE_REF}
                  placeholder={'Nhập nội dung...'}
                  editorContent={risk?.bien_phap_phong_ngua_giam_thieu}
                />
              )}
            </Form.Item>
          </Tabs.TabPane>
        </Tabs>

        <div className="custom-modal-footer">
          <Button
            className="custom-ant-button w-160"
            onClick={risk ? handleCancelEditModal : handleCancelCreateModal}>
            Hủy
          </Button>
          <Button
            className="custom-ant-button w-160"
            disabled={buttonBlock ? true : false}
            type={'primary'}
            htmlType={'submit'}>
            {risk ? 'Cập nhật' : 'Tạo mới'}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

export default RiskTemplateCreateModal
